import React from 'react';
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import ProjectInfo from "../components/ProjectInfo";
import AvailabilityCounter from "../components/AvailabilityCounter";
import Gallery from "../components/Gallery";
import ContactForm from "../components/ContactForm";
import Location from "../components/Location";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Benefits />
      <ProjectInfo />
      <AvailabilityCounter />
      <Gallery />
      <Location />
      <ContactForm />
    </>
  );
};

export default HomePage;